import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Badge, Spinner, Alert, Button, Nav, Tab
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { API_BASE_URL } from "../constants/api";
import StockCritique from "./StockCritique";
import RuptureStock from "./RuptureStock";
import Surstock from "./Surstock";


export default function AlertesStock() {
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('critique');

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${API_BASE_URL}/stock_alertes.php?action=stats`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setStats(result.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 100px)' }}>
                        <div className="text-center">
                            <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem', color: '#21ACCD' }} role="status">
                                <span className="visually-hidden">Chargement...</span>
                            </div>
                            <h5 className="text-muted">Chargement des alertes...</h5>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    if (error) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <Alert variant="danger" className="border-0 shadow-sm rounded-3">
                        <div className="d-flex align-items-center">
                            <i className="ri-error-warning-line fs-1 me-3 text-danger"></i>
                            <div>
                                <h6 className="mb-1 fw-bold">Erreur de chargement</h6>
                                <p className="mb-0 small">{error}</p>
                                <Button variant="outline-danger" size="sm" className="mt-2 rounded-pill" onClick={fetchStats}>
                                    <i className="ri-refresh-line me-1"></i>Réessayer
                                </Button>
                            </div>
                        </div>
                    </Alert>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>
                <div className="container-fluid">
                    {/* En-tête simplifié */}
                    <div className="d-md-flex align-items-center justify-content-between mb-4">
                        <div>
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <div className="p-2 bg-primary bg-opacity-10 rounded-3">
                                    <i className="ri-alert-line fs-20 text-primary" style={{ color: '#21ACCD' }}></i>
                                </div>
                                <div>
                                    <h4 className="main-title mb-0 fw-bold">Alertes stock</h4>
                                    <p className="text-muted small mb-0">Surveillance des niveaux de stock</p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex gap-2 mt-3 mt-md-0">
                            <Button 
                                variant="outline-secondary" 
                                onClick={() => navigate('/stock/etat/instantane')}
                                className="rounded-pill px-3 d-flex align-items-center gap-1"
                                size="sm"
                            >
                                <i className="ri-arrow-left-line"></i>
                                Retour
                            </Button>
                        </div>
                    </div>

                    {/* KPI Cards modernes */}
                    {stats && (
                        <Row className="g-3 mb-4">
                            <Col sm={6} xl={4}>
                                <div className="kpi-card kpi-danger">
                                    <div className="kpi-icon">
                                        <i className="ri-close-circle-line fs-24"></i>
                                    </div>
                                    <div className="kpi-content">
                                        <span className="kpi-label">Rupture</span>
                                        <h3 className="kpi-value">{stats.compteurs?.total_rupture || 0}</h3>
                                        <span className="kpi-unit">produits épuisés</span>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={6} xl={4}>
                                <div className="kpi-card kpi-warning">
                                    <div className="kpi-icon">
                                        <i className="ri-alert-line fs-24"></i>
                                    </div>
                                    <div className="kpi-content">
                                        <span className="kpi-label">Stock critique</span>
                                        <h3 className="kpi-value">{stats.compteurs?.total_critique || 0}</h3>
                                        <span className="kpi-unit">sous seuil</span>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={6} xl={4}>
                                <div className="kpi-card kpi-info">
                                    <div className="kpi-icon">
                                        <i className="ri-arrow-up-line fs-24"></i>
                                    </div>
                                    <div className="kpi-content">
                                        <span className="kpi-label">Surstock</span>
                                        <h3 className="kpi-value">{stats.compteurs?.total_surstock || 0}</h3>
                                        <span className="kpi-unit">au-dessus max</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}

                    {/* Onglets stylisés */}
                    <Card className="border-0 shadow-sm rounded-3">
                        <Card.Header className="bg-transparent border-bottom pt-3 pb-0">
                            <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="alertes-tabs">
                                <Nav.Item>
                                    <Nav.Link eventKey="critique">
                                        <Badge className="me-2" style={{ background: '#f59e0b' }}>{stats?.compteurs?.total_critique || 0}</Badge>
                                        Stock critique
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="rupture">
                                        <Badge className="me-2" style={{ background: '#ef4444' }}>{stats?.compteurs?.total_rupture || 0}</Badge>
                                        Rupture
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="surstock">
                                        <Badge className="me-2" style={{ background: '#0ea5e9' }}>{stats?.compteurs?.total_surstock || 0}</Badge>
                                        Surstock
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <Tab.Content>
                                <Tab.Pane active={activeTab === 'critique'}>
                                    <StockCritique />
                                </Tab.Pane>
                                <Tab.Pane active={activeTab === 'rupture'}>
                                    <RuptureStock />
                                </Tab.Pane>
                                <Tab.Pane active={activeTab === 'surstock'}>
                                    <Surstock />
                                </Tab.Pane>
                            </Tab.Content>
                        </Card.Body>
                    </Card>
                </div>
                <Footer />
            </div>

            <style>{`
                /* KPI Cards */
                .kpi-card {
                    background: white;
                    border-radius: 0px;
                    padding: 1rem;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    transition: all 0.2s ease;
                    height: 100%;
                    border-left: 2px solid;
                }
                .kpi-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
                }
                .kpi-danger { border-left-color: #ef4444; }
                .kpi-warning { border-left-color: #f59e0b; }
                .kpi-info { border-left-color: #0ea5e9; }
                
                .kpi-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .kpi-danger .kpi-icon { background: #fef2f2; color: #ef4444; }
                .kpi-warning .kpi-icon { background: #fffbeb; color: #f59e0b; }
                .kpi-info .kpi-icon { background: #e2f3f5; color: #0ea5e9; }
                
                .kpi-content {
                    flex: 1;
                }
                .kpi-label {
                    font-size: 0.7rem;
                    text-transform: uppercase;
                    color: #6c757d;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                }
                .kpi-value {
                    font-size: 1.3rem;
                    font-weight: 700;
                    margin: 0.25rem 0;
                    color: #1a3c5e;
                }
                .kpi-unit {
                    font-size: 0.7rem;
                    color: #6c757d;
                }
                
                /* Alertes Tabs */
                .alertes-tabs {
                    border-bottom: 2px solid #e2e8f0;
                }
                .alertes-tabs .nav-link {
                    border: none;
                    color: #64748b;
                    font-weight: 500;
                    padding: 0.75rem 1.5rem;
                    transition: all 0.2s ease;
                    background: transparent;
                }
                .alertes-tabs .nav-link:hover {
                    color: #21ACCD;
                    background: rgba(33, 172, 205, 0.05);
                }
                .alertes-tabs .nav-link.active {
                    color: #21ACCD;
                    background: transparent;
                    border-bottom: 2px solid #21ACCD;
                }
                
                .rounded-3 {
                    border-radius: 12px !important;
                }
                
                .rounded-pill {
                    border-radius: 50px !important;
                }
                
                .fs-20 {
                    font-size: 1.25rem;
                }
                .fs-24 {
                    font-size: 1.5rem;
                }
            `}</style>
        </>
    );
}